import { ChevronUp, PlusCircle, RotateCcw, User } from 'feather-icons-react/build/IconComponents'
import React,{useState,useEffect} from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { setToogleHeader } from '../../../core/redux/action';
import SettingsSidebar from '../settingssidebar';
import { updateUser,getUserById,uploadProfilePic } from "../../../service/ApiServices";
import Swal from "sweetalert2";

const GeneralSettings = () => {
        const[id,setId]=useState('')
        const [user, setUser] = useState(null);
        const [name, setName] = useState('');
        const [phone, setPhone] = useState('');
        const [email, setEmail] = useState('');
        const [description, setDescription] = useState('');
        const [profileImage, setProfileImage] = useState(null);
        const [previewImage, setPreviewImage] = useState('');

    const dispatch = useDispatch();
    const data = useSelector((state) => state.toggle_header);

    const renderRefreshTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Refresh
        </Tooltip>
    );
    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Collapse
        </Tooltip>
    )

    useEffect(() => {
        const storedUserData = localStorage.getItem("user");
        if (storedUserData) {
            const storeData = JSON.parse(storedUserData);
            setId(storeData.data._id);
        }
    }, []);
    
    useEffect(() => {
        const fetchUserDetails = async () => {
            if (!id) return; // wait until id is set
            try {
                const userData = await getUserById(id);
                setUser(userData);
                setName(userData.name);
                setPhone(userData.phone);
                setEmail(userData.email);
                setDescription(userData.description);
                if (userData.profilePic) {
                    console.log(userData.profilePic)
                    setPreviewImage(userData.profilePic);
                }
            } catch (error) {
                Swal.fire({
                    icon: "error",
                    title: "Error...",
                    text: error.message,
                });
            }
        };
    
        fetchUserDetails();
    }, [id]);

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            setProfileImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleUpdateUser = async (e) => {
            e.preventDefault();
    
            try {
                
                
                if (profileImage) {
                    const formData = new FormData();
                    formData.append("profilePic", profileImage);
                    await uploadProfilePic(id, profileImage);
                    
                }

                await updateUser(id, {
                    name,
                    phone,
                    email,
                    description,
                    
                });
                
                Swal.fire({
                  icon: "success",
                  title: "User Updated!",
                  text: "The User has been updated successfully.",
                });
    
            } catch (error) {
              if (error) {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: error.message,
                });
                return;
              }
            }
        };
    
        const handleCancel = () => {
            if (user) {
                setName(user.name || '');
                setPhone(user.phone || '');
                setEmail(user.email || '');
                setDescription(user.description || '');
                setPreviewImage(user.profilePic ? `/uploads/avatar/${user.profilePic}` : '');
                setProfileImage(null);
            }
        };

    return (
        <div>
            <div className="page-wrapper">
                <div className="content settings-content">
                    <div className="page-header settings-pg-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Settings</h4>
                                <h6>Manage your settings on portal</h6>
                            </div>
                        </div>
                        <ul className="table-top-head">
                            <li>
                                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <RotateCcw />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                                    <Link
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id="collapse-header"
                                        className={data ? "active" : ""}
                                        onClick={() => {dispatch(setToogleHeader(!data)) }}
                                    >
                                        <ChevronUp />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul>
                    </div>
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="settings-wrapper d-flex">
                            <SettingsSidebar/>
                                <div className="settings-page-wrap">
                                    <form>
                                        <div className="setting-title">
                                            <h4>Profile Settings</h4>
                                        </div>
                                        <div className="card-title-head">
                                            <h6>
                                                <span>
                                                    <User className="feather-chevron-up"/>
                                                </span>
                                                User Information
                                            </h6>
                                        </div>
                                        <div className="profile-pic-upload">
                                            <div className="profile-pic">
                                                {previewImage ? (
                                                    <img 
                                                        src={previewImage} 
                                                        alt="Profile" 
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover',
                                                            borderRadius: '10px'
                                                        }}
                                                    />
                                                ) : (
                                                    <span>
                                                        <PlusCircle className="plus-down-add"/>
                                                        Profile Photo
                                                    </span>
                                                )}
                                            </div>
                                            <div className="new-employee-field">
                                                <div className="mb-0">
                                                    <div className="image-upload mb-0">
                                                        <input 
                                                            type="file" 
                                                            onChange={handleFileChange}
                                                            accept="image/*"
                                                        />
                                                        <div className="image-uploads">
                                                            <h4>Change Image</h4>
                                                        </div>
                                                    </div>
                                                    <span>
                                                        For better preview recommended size is 450px x 450px. Max
                                                        size 5MB.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">User Name</label>
                                                    <input type="text" className="form-control" 
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">Phone</label>
                                                    <input type="text" className="form-control" 
                                                    value={phone}
                                                    onChange={(e) => setPhone(e.target.value)}/>
                                                </div>
                                            </div>
                                
                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">Email</label>
                                                    <input type="email" className="form-control"
                                                     value={email}
                                                     onChange={(e) => setEmail(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                            <div className=" input-blocks">
                                                    <label className="form-label">Descriptions</label>
                                                    <textarea
                                                        value={description}
                                                        onChange={(e) => setDescription(e.target.value)}
                                                    />
                                                    <p>Maximum 600 Characters</p>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="text-end settings-bottom-btn">
                                            <button type="button" className="btn btn-cancel me-2" onClick={handleCancel}>
                                                Cancel
                                            </button>
                                            <button type="button" className="btn btn-submit" onClick={handleUpdateUser}>
                                                Save Changes
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GeneralSettings
